import Pagination from 'react-bootstrap/Pagination';

function CustomPagination({
  dataPerPage,
  totalData,
  paginate,
  currentPage,
}) {
  const pageNumbers = [];
  for (let i = 1; i <= Math.ceil(totalData / dataPerPage); i += 1) {
    pageNumbers.push(i);
  }
  let start = 1;
  let end = pageNumbers.length;
  if (currentPage - 2 > 1) {
    start = currentPage - 2;
  }
  if (currentPage + 2 < pageNumbers.length) {
    end = currentPage + 2;
  }

  const totalRecords = Number(totalData) || 0;
  const startRecord = totalRecords === 0 ? 0 : (currentPage - 1) * dataPerPage + 1;
  const endRecord = Math.min(currentPage * dataPerPage, totalRecords);

  return (
    <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mt-4">
      <span className="text-muted fs-7">
        Showing
        {' '}
        {startRecord}
        -
        {endRecord}
        {' '}
        of
        {' '}
        {totalRecords}
        {' '}
        records
      </span>
      <Pagination className="mb-0">
        <Pagination.Prev
          onClick={() => paginate(currentPage - 1)}
          disabled={currentPage === 1}
        />
        {start !== 1 && <Pagination.Ellipsis />}
        {pageNumbers.slice(start - 1, end).map((number) => (
          <Pagination.Item
            key={number}
            onClick={() => paginate(number)}
            active={currentPage === number}
          >
            {number}
          </Pagination.Item>
        ))}
        {end !== pageNumbers.length && <Pagination.Ellipsis />}
        <Pagination.Next
          onClick={() => paginate(currentPage + 1)}
          disabled={currentPage === pageNumbers.length}
        />
      </Pagination>
    </div>
  );
}
export default CustomPagination;
